import RestartAlt from '@mui/icons-material/RestartAlt';
import PriorityHigh from '@mui/icons-material/PriorityHigh';
import { Box, SxProps, Theme } from '@mui/material';

interface ResurgentThreatIconProps {
  size?: number;
  sx?: SxProps<Theme>;
}

const ResurgentThreatIcon = ({ size = 24, sx }: ResurgentThreatIconProps) => (
  <Box
    sx={{
      position: 'relative',
      width: size,
      height: size,
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      ...(sx as object),
    }}>
    <RestartAlt sx={{ fontSize: size }} />
    <PriorityHigh
      sx={{
        fontSize: size * 0.45,
        marginTop: '2px',
        position: 'absolute',
      }}
    />
  </Box>
);

export default ResurgentThreatIcon;
